import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { RequestServiceBase } from './RequestServiceBase';
import { Observable } from 'rxjs';
import { environment } from '../ofc.env';
import { SystemType } from 'src/app/model/enums/system.type';


@Injectable({
  providedIn: 'root'
})

export class HttpService extends RequestServiceBase {

  constructor(public http: HttpClient) {
    super(http);
  }

  // #region "kanban module"
  getReportedIssue(): Observable<any> {
    return this.get(`${environment.API_URL}${environment.ENDPOINT_PREFIX}/reported-issues`);
  }


  reportedIssue(data:any , type : SystemType): Observable<any> {
    return this.post(`${environment.API_URL}${environment.ENDPOINT_PREFIX}/reported-issues?type=${type}`, data, 1);
  }
  // #endregion

}
